import { type RouteRecordRaw } from "vue-router";
import { canAccess, permissionList } from "@/utilities/authorization";

const roleRoutes: RouteRecordRaw[] = [
    {
        name: 'role',
        path: '/role',
        component: () => import('@/views/role/RoleIndex.vue'),
        beforeEnter: () => canAccess(permissionList.SUPER_USER)
    },
    {
        name: 'role-new',
        path: '/role/new',
        component: () => import('@/views/role/NewRole.vue'),
        beforeEnter: () => canAccess(permissionList.SUPER_USER)
    },
    {
        name: 'role-edit',
        path: '/role/edit/:id(\\d+)',
        component: () => import('@/views/role/EditRole.vue'),
        beforeEnter: () => canAccess(permissionList.SUPER_USER)
    },
    {
        name: 'role-detail',
        path: '/role/detail/:id(\\d+)',
        component: () => import('@/views/role/RoleDetail.vue'),
        beforeEnter: () => canAccess(permissionList.SUPER_USER)
    },
]

export default roleRoutes
